import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="results-title" data-id="element-148" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-149" data-mp="28ddhl9rhabqq">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-150" data-mp="2d6zvt6dainon">
          What educators using this collection say
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-151" data-mp="2m6mq787lqt87">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-line bg-mist p-6 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-152" data-mp="2r6r4qsoy9dvs" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-green" aria-hidden="true" data-id="element-153" data-mp="3nf0piwh5oozz" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-154" data-mp="3img1kbkxl64d">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-line pt-4" data-id="element-155" data-mp="3doo6x9swj5wh">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-navy text-sm font-extrabold text-white" data-id="element-156" data-mp="38pbapyg54mh8">
                  {initials}
                </span>
                <span data-id="element-157" data-mp="57b6mudph18w">
                  <b className="block text-sm text-ink" data-id="element-158" data-mp="594iqp738doa">{name}</b>
                  <small className="text-xs text-muted" data-id="element-159" data-mp="871qfxtdpod">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}